import Splide from '@splidejs/splide';
import { pageWidth } from '../functions/windowSizeFunctions';
import { throttle } from '../functions/helperFunctions';

export default class HeroSlider {
    constructor() {
        this.heroSlider = document.querySelector('.jsHeroSlider');
        this.activeSlider = null;

        if (this.heroSlider) {
            this.events();
        }
    }

    events() {
        this.initializeHeroSlider();

        window.addEventListener(
            'resize',
            throttle(this.rebuildSliderIfNeeded.bind(this), 150),
        );
    }

    setSliderOptions() {
        const currentPageWidth = pageWidth();

        const sliderOptions = {
            arrows: false,
            autoplay: true,
            classes: {
                // Add classes for pagination.
                pagination: 'splide__pagination fp-hero-slider__pagination', // container
            },
        };

        if (currentPageWidth < 1024) {
            sliderOptions.type = 'loop';
            sliderOptions.perPage = 1;
            sliderOptions.perMove = 1;
        } else {
            sliderOptions.type = 'fade';
            sliderOptions.rewind = true;
        }

        return sliderOptions;
    }

    initializeHeroSlider() {
        const sliderOptions = this.setSliderOptions();

        // eslint-disable-next-line no-unused-vars
        this.activeSlider = new Splide(this.heroSlider, sliderOptions).mount();
    }

    rebuildSliderIfNeeded() {
        const currentPageWidth = pageWidth();

        if (!this.activeSlider) return;

        if (
            (currentPageWidth >= 1024 && this.activeSlider.is('loop')) ||
            (currentPageWidth < 1024 && this.activeSlider.is('fade'))
        ) {
            this.activeSlider.destroy('completely');
            this.activeSlider = null;
            this.initializeHeroSlider();
        }
    }
}
